var map = {
	"./DE.png": "8a2b",
	"./EN-GB.png": "711d",
	"./EN-UK.png": "0474",
	"./ES.png": "e9a1",
	"./FR.png": "e2ab",
	"./Logo_black.png": "55ef",
	"./Logo_white.png": "165a",
	"./RU.png": "acb4",
	"./SV.png": "6482",
	"./ZH.png": "0def",
	"./cardinal_logo_black.png": "026c",
	"./cardinal_logo_white.png": "d1fd",
	"./github_icon_black.png": "d5d7",
	"./github_icon_white.png": "7861",
	"./google_icon_black.png": "f513",
	"./google_icon_white.png": "c16a",
	"./masspredict_by_you.png": "a63a",
	"./slack_icon_black.png": "e861",
	"./slack_icon_white.png": "0149"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";